export enum VATType {
  ExVAT = 'Ex VAT',
  IncludedVAT = 'Incl Vat'
}
